<script>
export default {
  name: 'OverviewIcon',
};
</script>

<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->
    <title>icon/overview</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g id="Symbols" 
       stroke="none" 
       stroke-width="1" 
       fill="none" 
       fill-rule="evenodd">
      <g id="icon/overview" fill="#7C8482">
        <path
          id="Fill-1"
          d="M12.33975,10.3925 C11.58575,10.3925 10.97475,9.7815 10.97475,9.0275 C10.97475,8.3785 11.42875,7.8365 12.03675,7.6995 C11.62575,7.4905 11.16675,7.3605 10.67275,7.3605 C8.99875,7.3605 7.64175,8.7185 7.64175,10.3925 C7.64175,12.0665 8.99875,13.4245 10.67275,13.4245 C12.34675,13.4245 13.70475,12.0665 13.70475,10.3925 C13.70475,10.1115 13.65375,9.8445 13.58275,9.5865 C13.36875,10.0605 12.89375,10.3925 12.33975,10.3925 M10.67275,15.3415 C7.93975,15.3415 5.72375,13.1255 5.72375,10.3925 C5.72375,7.6595 7.93975,5.4435 10.67275,5.4435 C13.40575,5.4435 15.62175,7.6595 15.62175,10.3925 C15.62175,13.1255 13.40575,15.3415 10.67275,15.3415 M20.85975,9.2175 L17.44875,5.8065 C13.70675,2.0645 7.63875,2.0645 3.89775,5.8065 L0.48675,9.2175 C-0.16225,9.8665 -0.16225,10.9185 0.48675,11.5675 L3.89775,14.9785 C7.63875,18.7205 13.70675,18.7205 17.44875,14.9785 L20.85975,11.5675 C21.50775,10.9185 21.50775,9.8665 20.85975,9.2175"
        />
      </g>
    </g>
  </svg>
</template>
